import { render, staticRenderFns } from "./TractDestinationForm.vue?vue&type=template&id=0c39e2d4&"
import script from "./TractDestinationForm.vue?vue&type=script&lang=js&"
export * from "./TractDestinationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports